/* eslint-disable @typescript-eslint/no-explicit-any */
import { Filter, StatusOption } from 'utils/__interfaces/Billings/BillEntity'
import { statusOptions } from 'utils/__consts/Billings/BillEntity'

export function getFilterForId(filters: Filter[], id: string): any {
  const filter = filters.find((f) => f.id === id)
  return filter?.value
}

export const getStatusLabel = (apiValue: string) => {
  const found = statusOptions.find(
    (option: StatusOption) => option.value === apiValue
  )
  return found ? found.label : statusOptions[0].label
}
